module.exports = __webpack_public_path__ + "static/work-nicer-5ef100b25336102a947f146df56cdbfe.png";